/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FuelTypeFromJSON, FuelTypeToJSON, OrderedFileDtoFromJSON, OrderedFileDtoToJSON, } from './';
export function CarBasicDtoFromJSON(json) {
    return CarBasicDtoFromJSONTyped(json, false);
}
export function CarBasicDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'carModelId': !exists(json, 'carModelId') ? undefined : json['carModelId'],
        'carModelName': !exists(json, 'carModelName') ? undefined : json['carModelName'],
        'carMakeName': !exists(json, 'carMakeName') ? undefined : json['carMakeName'],
        'carMakeId': !exists(json, 'carMakeId') ? undefined : json['carMakeId'],
        'manufactureYear': !exists(json, 'manufactureYear') ? undefined : json['manufactureYear'],
        'plateNumber': !exists(json, 'plateNumber') ? undefined : json['plateNumber'],
        'enginePower': !exists(json, 'enginePower') ? undefined : json['enginePower'],
        'calendarColorRGB': !exists(json, 'calendarColorRGB') ? undefined : json['calendarColorRGB'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'fuel': !exists(json, 'fuel') ? undefined : FuelTypeFromJSON(json['fuel']),
        'photos': !exists(json, 'photos') ? undefined : (json['photos'] === null ? null : json['photos'].map(OrderedFileDtoFromJSON)),
        'mainPhoto': !exists(json, 'mainPhoto') ? undefined : OrderedFileDtoFromJSON(json['mainPhoto']),
        'modelPhotos': !exists(json, 'modelPhotos') ? undefined : (json['modelPhotos'] === null ? null : json['modelPhotos'].map(OrderedFileDtoFromJSON)),
    };
}
export function CarBasicDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'carId': value.carId,
        'carModelId': value.carModelId,
        'carModelName': value.carModelName,
        'carMakeName': value.carMakeName,
        'carMakeId': value.carMakeId,
        'manufactureYear': value.manufactureYear,
        'plateNumber': value.plateNumber,
        'enginePower': value.enginePower,
        'calendarColorRGB': value.calendarColorRGB,
        'location': value.location,
        'fuel': FuelTypeToJSON(value.fuel),
        'photos': value.photos === undefined ? undefined : (value.photos === null ? null : value.photos.map(OrderedFileDtoToJSON)),
        'mainPhoto': OrderedFileDtoToJSON(value.mainPhoto),
        'modelPhotos': value.modelPhotos === undefined ? undefined : (value.modelPhotos === null ? null : value.modelPhotos.map(OrderedFileDtoToJSON)),
    };
}
